import * as React from 'react';

const SVGLoginIllustration: React.SFC<SvgProps> = props => (
  <svg viewBox="0 0 338 274" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M0 274h81.609s28.294-1.498 47.324-28.603c0 0 9.353-17.209 29.357-20.527 0 0 37.323-9.603 35.907-33.537H.147L0 274z"
        fill="#DEEDF2"
        fillRule="nonzero"
      />
      <ellipse
        fill="#DEEDF2"
        fillRule="nonzero"
        cx={154.187}
        cy={85.667}
        rx={71.086}
        ry={71}
      />
      <path
        d="M221.013 61s11.858 31.136 47.313 13.529L259.499 140l-63.26-1.526L221.012 61z"
        fill="#DEEDF2"
        fillRule="nonzero"
      />
      <ellipse
        fill="#DEEDF2"
        fillRule="nonzero"
        cx={285.514}
        cy={112.5}
        rx={41.884}
        ry={41.833}
      />
      <path
        d="M279.677 51.403c-.119-3.087 2.578-5.626 5.777-5.626.267 0 .534.028.8.057.534-2.568 2.844-4.5 5.66-4.5 2.903 0 5.273 2.077 5.688 4.789a5.621 5.621 0 0 1 1.985-.346c3.17 0 5.777 2.51 5.777 5.626v.086h3.2c1.54 0 2.814 1.24 2.814 2.741 0 1.5-1.274 2.741-2.814 2.741h-8.444c-.178.029-.356.029-.533.029-.178 0-.356 0-.534-.029h-13.095s-6.074-.058-6.281-5.568z"
        fill="#C3DEE7"
        fillRule="nonzero"
      />
      <path
        d="M.147 192h261.924s24.533 0 24.533-26.58c0 0 1.386-8.625 10.025-11.774 0 0 22.056-7.536 27.098-23.254H38.42s-16.57-1.678-22.792 12.951c0 0-1.652 8.537-12.561 8.537H0L.147 192z"
        fill="#DEEDF2"
        fillRule="nonzero"
      />
      <ellipse
        fill="#9BC3D3"
        fillRule="nonzero"
        cx={224.106}
        cy={137.833}
        rx={8.177}
        ry={1}
      />
      <g transform="translate(222.27 22.333)" fillRule="nonzero">
        <path
          d="M4.796 97.77l-2.177 7.433s-.147 1.416 1.353 1.976c0 0 1.118.502 2.06 0l3.943-7.432-5.179-1.976z"
          fill="#F9C8BC"
        />
        <ellipse fill="#9BC3D3" cx={15.889} cy={79.219} rx={4.678} ry={4.689} />
        <path
          d="M11.24 78.482l9.328-28.402 10.533.53s.824 7.109-4.53 16.576l-7.68 14.068-7.65-2.772z"
          fill="#9BC3D3"
        />
        <path
          fill="#9BC3D3"
          d="M11.24 78.512L5.09 96.916l5.562 2.27L19.92 81.55zM4.296 96.65l6.944 2.831-1.412 2.036-6.297-2.743z"
        />
        <path
          d="M4.296 105.764l1.707 1.415 3.119 5.87s.147.294.647.5l1.206.414-.5 1.062s-.324.5-1.118.5H6.59s-.912-.058-1.707-1.06l-4.59-5.103s-.412-.56 0-1.268l1.913-3.127s-.118-.177.588-.295l1.5 1.092z"
          fill="#FFF"
        />
        <path
          fill="#000"
          d="M30.248 16.84l-2.265 5.133-2.708-1.357 2.708-4.395z"
        />
        <path
          d="M24.952 106.058l2.06 8.642s3.324.56 4.443-.914l-.56-8.347-5.943.62z"
          fill="#F9C8BC"
        />
        <path
          d="M43.813 32.148l-3.767-2.39c-.176-.117-.205-.324-.117-.5l5.149-8.082c.118-.177.324-.206.5-.118l3.767 2.39c.176.117.206.324.117.5l-5.149 8.082c-.118.177-.353.236-.5.118z"
          fill="#1BB3BC"
        />
        <ellipse fill="#F9C8BC" cx={31.072} cy={25.659} rx={3.531} ry={3.539} />
        <path fill="#F9C8BC" d="M34.574 26.279l-2.001 9.91-5.032-.59v-9.94z" />
        <ellipse fill="#F9C8BC" cx={30.778} cy={44.889} rx={3.413} ry={3.421} />
        <path
          fill="#F9C8BC"
          d="M28.748 42.087l12.299-10.323 3.03 1.918-10.68 13.42z"
        />
        <path
          d="M24.716 17.667l7.15 4.542 1.207 9.555s.206.65-.412 3.835L30.954 50.61l-16.83-.856-3.502-27.37 14.094-4.718z"
          fill="#D2F0F2"
        />
        <path fill="#E59D27" d="M27.983 42.087h-4.296l-.707-9.113h5.709z" />
        <path fill="#FFF" d="M29.307 32.974h-6.945l.707-1.652H28.6z" />
        <path
          d="M41.047 31.764v-2.33s-.147-1.268 1.06-1.415l4.295.56 1.618-2.684s.148-.236.324-.236c.177 0 .56.089.412.65l-1.147 4.099s-.354 1.356-1.119 1.71l-2.412 1.564-3.031-1.918z"
          fill="#F9C8BC"
        />
        <path
          d="M14.065 49.755s-3.59 7.433-1.06 16.635l7.769 20.881 9.327-.649-4.708-36.336-11.328-.53z"
          fill="#9BC3D3"
        />
        <ellipse fill="#9BC3D3" cx={25.423} cy={87.065} rx={4.678} ry={4.689} />
        <path
          fill="#9BC3D3"
          d="M20.774 87.3l3.09 20.528 8.003-.914L30.1 86.652z"
        />
        <path
          fill="#9BC3D3"
          d="M23.245 107.887l9.593-1.12v1.975l-9.18 1.062z"
        />
        <path
          d="M26.982 114.76l.353 3.892s.206 1.357 1.471 1.475h5.591l5.59-.708s.413-.295.5-.649v-1.091s-4.53-1.062-5.384-1.71l-3.678-2.183-4.443.973z"
          fill="#FFF"
        />
        <ellipse fill="#F9C8BC" cx={11.24} cy={25.895} rx={3.531} ry={3.539} />
        <ellipse fill="#F9C8BC" cx={5.708} cy={45.007} rx={3.531} ry={3.539} />
        <path
          fill="#F9C8BC"
          d="M14.624 26.84L9.15 45.802l-6.856-1.651 5.532-19.23z"
        />
        <path
          fill="#F9C8BC"
          d="M5.296 41.497l16.243-3.775 1.206 3.392-15.83 7.226z"
        />
        <path
          d="M21.539 37.722l1.618-1.828s.853-.65 1.824-.767l3.59-.413s.56 0 .647.413c0 0 .06.295-.353.649 0 0-.294.353-.059.766 0 0 .295.502-.353 1.21 0 0-.206.354-.353.707l-.647 1.564s-.206.56-.765.56l-3.943.56-1.206-3.42zM32.484 1.976s4.208 1.298 2.972 6.902l-1.853 5.603-1.119-.383-1.794 2.86s-.765 1.21-2.766.532l-2.001 4.837s-1.648 1.297-4.414 0c0 0-1.648-.856-1.854-2.684l4.09-9.38s-1.942.06-1.383-2.211c0 0 .412-1.888 2.06-1.563 0 0 .971.383.618 1.356-.03 0 1.412-7.491 7.444-5.869z"
          fill="#F9C8BC"
        />
        <path
          d="M31.984 5.368s.912 2.36 4.09 2.92c0 0 2.001-5.81-3.678-7.875 0 0-6.973-2.478-10.74 4.955L14.948 20.94l4.678-1.297 4.09-9.38s-1.736.119-1.324-2.211c0 0 .265-1.74 1.824-1.475 0 0 .971.089.824 1.268-.03 0 4.473.384 6.944-2.477z"
          fill="#000"
        />
        <path
          d="M27.924 17.49s-1.413-.443-2.649-1.269l1.972 2.861.677-1.592z"
          fill="#F9BEB0"
        />
      </g>
      <ellipse
        fill="#E59D27"
        fillRule="nonzero"
        cx={202.746}
        cy={203.833}
        rx={1.502}
        ry={1.5}
      />
      <ellipse
        fill="#9BC3D3"
        fillRule="nonzero"
        cx={327.898}
        cy={90.833}
        rx={1.502}
        ry={1.5}
      />
      <ellipse
        fill="#FFF"
        fillRule="nonzero"
        cx={113.638}
        cy={44.5}
        rx={1.502}
        ry={1.5}
      />
      <ellipse
        fill="#1BB3BC"
        fillRule="nonzero"
        cx={216.43}
        cy={51.833}
        rx={1.502}
        ry={1.5}
      />
      <g fillRule="nonzero">
        <path
          d="M303.666 156.862h27.245s1.115 0 1.965.648l2.258 1.856s1.907 1.62-.264 2.563h-31.204l-5.367-1.768v-1.502l5.367-1.797z"
          fill="#9BC3D3"
        />
        <path
          fill="#9BC3D3"
          d="M305.514 156.862l-5.103-5.597h-1.613l1.32 6.805z"
        />
        <path
          fill="#C3DEE7"
          d="M298.3 158.688l-.822.148v1.207l.821.148zM319.063 160.75l-.792.148v2.003l.792.177z"
        />
        <path
          fill="#9BC3D3"
          d="M302.053 159.219h-2.903l-2.405-1.915h1.789zM320.881 160.397h-5.484l-3.871-4.743h2.111zM319.063 160.397h4.81v3.034h-4.81z"
        />
      </g>
      <path d="M290.293 158.924h4.34M287.742 157.333h4.34" stroke="#9BC3D3" />
      <g transform="translate(216.597 156)" fillRule="nonzero">
        <path
          d="M77.997 37.316c-.648-1.88 1.15-3.232 1.916-3.702.118-.059.236-.118.324-.176a3.343 3.343 0 0 0 1.563-2.85 3.385 3.385 0 0 0-3.39-3.38c-1.061 0-2.005.5-2.624 1.234-1.415 1.44-3.301.823-4.038.588a1.44 1.44 0 0 0-.324-.117 5.08 5.08 0 0 0-1.769-.294c-2.948 0-5.365 2.38-5.365 5.347a5.317 5.317 0 0 0 4.687 5.29c-1.857.528-3.242 2.232-3.242 4.26a4.455 4.455 0 0 0 2.711 4.084c-.943.823-1.562 2.027-1.562 3.379 0 2.468 2.005 4.437 4.451 4.437 1.68 0 3.125-.911 3.891-2.263a4.453 4.453 0 0 0 3.891 2.263 4.44 4.44 0 0 0 4.451-4.437c0-1.352-.59-2.556-1.532-3.35.442.089.884.118 1.326.118 3.655 0 6.603-2.938 6.603-6.582 0-3.643-2.948-6.582-6.603-6.582a6.569 6.569 0 0 0-5.365 2.733z"
          fill="#1BB3BC"
        />
        <path fill="#9BC3D3" d="M80.326 73.839H70.038l-3.89-20.98h18.069z" />
        <ellipse fill="#000" cx={46.84} cy={36.963} rx={8.047} ry={8.021} />
        <path
          d="M76.641 15.75h-4.775v-.118c0-4.731-3.862-8.58-8.608-8.58a8.473 8.473 0 0 0-2.977.529A8.599 8.599 0 0 0 51.762.264c-4.156 0-7.634 2.968-8.43 6.876a8.066 8.066 0 0 0-1.209-.088c-4.746 0-8.607 3.849-8.607 8.58v.117h-11.85c-2.329 0-4.215 1.91-4.215 4.202 0 2.321 1.916 4.202 4.215 4.202h19.661c.266.029.53.029.796.029.265 0 .53 0 .796-.03h19.573c.265.03.53.03.796.03.265 0 .53 0 .796-.03H76.64c2.329 0 4.216-1.91 4.216-4.201.029-2.321-1.887-4.202-4.216-4.202z"
          fill="#9BC3D3"
        />
        <path
          d="M45.16 14.985s0-7.463-10.996-6.523c0 0-9.757.558-12.292 14.486 0 0-.53 8.11-7.723 9.726-7.163 1.616-6.25 7.962-6.25 7.962s0 2.44 2.389 4.143c1.473 1.058.294 3.32.294 3.32S7.9 54.535 14.71 55.74l25.557-15.837 4.893-24.917z"
          fill="#000"
        />
        <path
          d="M40.974 37.904s14.326-.823 21.548 9.285l8.43 12.752-18.1 13.016H31.1L12.616 59.941 18.6 47.629c.03.03 4.098-9.725 22.374-9.725z"
          fill="#9E3667"
        />
        <path
          d="M31.128 72.987H17.716s-5.542 0-7.163-2.939c0 0-1.946-2.85.914-7.904l1.975-3.82 17.686 14.663zM52.882 72.987h15.8s5.277 0 5.277-5.377c0 0 .353-2.645-3.007-7.67l-18.07 13.047zM45.012 14.31s2.653.499 5.63 9.843l-1.533.822 1.003 7.11s.56 2.91-3.774 2.91l1.415 6.111s-5.07 4.82-11.584 1.558L33.84 28.913s-3.42.94-3.803-3.027c0 0-.206-3.026 2.182-2.997 0 0 1.179-.059 1.533 1 0 0 1.208-.56 1.326-3.997 0 0 .089-4.907 4.51-5.553.03-.03 1.74-.441 5.424-.03z"
          fill="#F9C8BC"
        />
        <path
          d="M46.309 34.965s-4.274-.293-5.394-.41l5.895 2.38-.501-1.97z"
          fill="#F9BEB0"
        />
        <path fill="#C3DEE7" d="M.118 72.987h93.325v3.085H.118z" />
        <path fill="#9BC3D3" d="M.118 76.013h93.325v3.085z" />
      </g>
      <g transform="translate(0 57.333)" fillRule="nonzero">
        <path
          d="M50.864 172.106s41.876 17.223 68.959 10.069l48.683-27.291 15.501-89.557L69.666 56.76 50.864 172.106z"
          fill="#F9BEB0"
        />
        <path
          d="M181.149 111.313c-5.099-.236-9.077-4.622-8.841-9.716l1.031-18.4c.236-5.093 4.627-9.067 9.725-8.832 5.098.236 9.077 4.623 8.84 9.716l-1.03 18.4c-.236 5.122-4.598 9.097-9.725 8.832z"
          fill="#F9C8BC"
        />
        <path
          d="M153.005 83.374c-2.534-5.152-.383-11.452 4.774-13.984l38.458-19.784c5.157-2.531 11.463-.382 13.998 4.77 2.534 5.152.383 11.452-4.774 13.984l-38.458 19.783c-5.157 2.532-11.463.383-13.998-4.769z"
          fill="#F9C8BC"
        />
        <path
          d="M121.237 182.675l-58.88-25.76c-6.159-2.679-9.076-9.715-6.483-15.603L113.84 8.832c2.594-5.888 9.725-8.508 15.884-5.83l58.85 25.731c6.16 2.68 9.077 9.716 6.484 15.604l-57.966 132.48c-2.564 5.917-9.696 8.537-15.855 5.858z"
          fill="#9E3667"
        />
        <path
          d="M117.465 181.115l-58.85-25.73c-6.16-2.68-9.077-9.716-6.484-15.633L110.157 7.124c2.593-5.888 9.725-8.537 15.884-5.829l58.85 25.73c6.16 2.68 9.077 9.716 6.483 15.634L133.35 175.286c-2.564 5.888-9.725 8.508-15.884 5.829z"
          fill="#FFF"
        />
        <path
          d="M117.465 181.115l-58.85-25.73c-6.16-2.68-9.195-9.421-6.778-14.956l54.4-124.355c2.417-5.534 9.43-7.86 15.59-5.152l58.85 25.73c6.16 2.68 9.194 9.422 6.778 14.956l-54.4 124.355c-2.417 5.535-9.43 7.83-15.59 5.152z"
          fill="#DEEDF2"
        />
        <ellipse fill="#DEEDF2" cx={166.944} cy={24.788} rx={1.562} ry={1.56} />
        <ellipse fill="#DEEDF2" cx={141.306} cy={13.601} rx={1.562} ry={1.56} />
        <ellipse fill="#DEEDF2" cx={136.001} cy={11.54} rx={1.562} ry={1.56} />
        <path
          d="M156.689 21.668l-10.668-4.475a1.35 1.35 0 0 1-.707-1.766 1.353 1.353 0 0 1 1.768-.707l10.668 4.475a1.35 1.35 0 0 1 .707 1.766c-.295.648-1.09.972-1.768.707z"
          fill="#DEEDF2"
        />
        <path
          d="M119.764 16.221l58.585 25.672c6.247 2.738 9.077 10.01 6.365 16.251L133.526 175.05l-81.218-35.593 51.16-116.877c2.74-6.24 10.019-9.096 16.296-6.359z"
          fill="#FFF"
        />
        <path
          d="M148.437 154.266c-2.21-4.622-.206-10.187 4.391-12.365l20.246-9.98c4.627-2.208 10.196-.206 12.377 4.386 2.21 4.622.206 10.186-4.39 12.365l-20.246 9.98c-4.598 2.208-10.167.236-12.378-4.386z"
          fill="#F9C8BC"
        />
        <path
          d="M148.26 143.196c-2.71-4.328-1.414-10.098 2.918-12.806l22.456-14.396c4.332-2.709 10.108-1.414 12.819 2.914 2.711 4.328 1.415 10.098-2.917 12.807L161.08 146.11c-4.332 2.708-10.108 1.413-12.82-2.915z"
          fill="#F9BEB0"
        />
        <path
          d="M149.675 135.424c-2.564-4.416-1.002-10.127 3.419-12.689l22.986-13.542c4.42-2.561 10.137-1.001 12.701 3.415s1.002 10.127-3.418 12.689l-22.987 13.542c-4.45 2.561-10.166 1.001-12.7-3.415zM.147 104.63h10.757s9.106-.795 13.85-10.628c0 0 7.25-16.516 22.84-26.32 0 0 14.704-10.51 20.068-20.401 0 0 8.958-14.632 12.701-19.784 0 0 3.978-6.124 9.99-2.915 0 0 6.955 3.21 2.682 21.462 0 0-3.92 13.425-10.933 18.165 0 0-7.633 6.388-7.633 17.958 0 0 2.8 35.387-17.151 69.95l-6.395 20.019H.147V104.63z"
          fill="#F9C8BC"
        />
        <path
          d="M154.538 121.558c-2.181-4.622-.177-10.186 4.45-12.365l24.047-11.6c4.626-2.178 10.196-.176 12.377 4.446 2.18 4.622.177 10.186-4.45 12.365l-24.047 11.6c-4.627 2.178-10.197.176-12.377-4.446z"
          fill="#F9BEB0"
        />
        <path
          d="M157.22 117.348c-2.623-4.387-1.15-10.128 3.241-12.718l15.913-9.303c4.391-2.62 10.138-1.148 12.731 3.238 2.623 4.387 1.15 10.127-3.241 12.718l-15.914 9.303c-4.39 2.62-10.108 1.148-12.73-3.238z"
          fill="#F9C8BC"
        />
      </g>
      <path
        fill="#9BC3D3"
        fillRule="nonzero"
        d="M111.584 144.872l37.518 15.799-1.037 2.457-37.518-15.799zM113.92 138.872l37.518 15.799-1.037 2.457-37.518-15.799zM116.924 132.206l37.518 15.798-1.037 2.457-37.518-15.798z"
      />
      <path
        fill="#EC0000"
        fillRule="nonzero"
        d="M103.365 80.065l81.802 34.446-.521 1.235-81.802-34.445z"
      />
      <path
        d="M130.371 202.942l-36.56-15.529a.603.603 0 0 1-.324-.77l3.321-7.943a.595.595 0 0 1 .765-.326l36.56 15.53c.294.118.44.473.323.77l-3.32 7.972c-.118.296-.471.444-.765.296z"
        fill="#9E3667"
        fillRule="nonzero"
      />
      <path
        d="M136.045 189.626l-36.56-15.54a.604.604 0 0 1-.324-.771l3.321-7.948a.595.595 0 0 1 .764-.326l36.56 15.54c.294.118.441.474.324.77l-3.321 7.949a.595.595 0 0 1-.764.326zM141.718 176.942l-36.56-15.529a.603.603 0 0 1-.323-.77l3.32-7.943a.595.595 0 0 1 .765-.326l36.56 15.53c.294.118.44.474.323.77l-3.32 7.942c-.148.326-.47.475-.765.326z"
        stroke="#9BC3D3"
        strokeWidth={0.75}
      />
      <path
        fill="#1BB3BC"
        fillRule="nonzero"
        d="M310.089 190.5l2.124-2.121 2.124 2.121-2.124 2.121z"
      />
      <path
        fill="#9BC3D3"
        fillRule="nonzero"
        d="M320.101 133.5l2.124-2.121 2.124 2.121-2.124 2.121z"
      />
      <path
        fill="#EC0000"
        fillRule="nonzero"
        d="M214.26 217.667v3h-3.003v-3z"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M215.033 158.333l-3.776 3.772-3.776-3.772 3.776-3.77z"
      />
      <g stroke="#9BC3D3">
        <path d="M267.158 42.07v-.734" />
        <path
          d="M267.158 39.87v-7.83s-.853-28.648-30.755-28.648h-69.368"
          strokeDasharray="5.0536,5.0536"
        />
        <path d="M166.27 3.392h-.736" />
      </g>
      <path
        d="M69.751 191.667L133.496 219"
        stroke="#9BC3D3"
        strokeWidth={0.75}
      />
      <g fillRule="nonzero">
        <path
          fill="#9BC3D3"
          d="M295.77 91.333h7.646v30h-7.646zM261.07 95.863h7.645v25.47h-7.646z"
        />
        <path fill="#FFF" d="M259.158 95.863h1.911v25.47h-1.911z" />
        <path fill="#9BC3D3" d="M295.77 106.951l-4.764-1.5v15.882h4.764z" />
        <path
          fill="#9BC3D3"
          d="M281.978 101.569h9.028v19.764h-9.028zM270.303 113.392h9.028v7.941h-9.028zM303.269 113.392h9.028v7.941h-9.028z"
        />
        <path
          fill="#FFF"
          d="M265.98 113.392h4.323v7.941h-4.323zM279.36 101.569h2.706v19.764h-2.705zM295.77 91.333h-2.735v14.706l2.735.97zM283.507 102.775h5.97v2.088h-5.97zM319.678 101.569h10.94v19.764h-10.94z"
        />
        <path fill="#9BC3D3" d="M320.501 107.451l-6.116-5.882v19.764h6.116z" />
        <path fill="#FFF" d="M312.356 101.569h2.117v19.764h-2.117z" />
      </g>
      <path
        fill="#DEEDF2"
        fillRule="nonzero"
        d="M257.646 121.333h79.764v3.334h-79.764z"
      />
      <g fill="#FFF" fillRule="nonzero">
        <path d="M279.1 213.472v-1.414h1.363v1.414zM281.358 213.45v-1.414h1.363v1.413zM283.957 213.462v-1.413h9.678v1.413z" />
      </g>
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M240.96 204.918l1.656-.585 15.683 1.725 16.067-1.725 1.302.702-17.369 2.632z"
      />
      <path
        fill="#E59D27"
        fillRule="nonzero"
        d="M258.314 229h-18.356v-24.333l18.356 2.082z"
      />
      <path
        fill="#946F00"
        fillRule="nonzero"
        d="M276.67 229h-18.356v-22.251l18.356-2.082z"
      />
      <path
        d="M233.283 219.208l2.614-2.948s1.364-1.022 2.932-1.255l5.779-.672s.9 0 1.016.672c0 0 .116.467-.552 1.021 0 0-.464.555-.116 1.256 0 0 .465.788-.551 1.926 0 0-.349.555-.552 1.139l-1.016 2.51s-.349.905-1.249.905l-6.33.905-1.975-5.459zM282.343 219.208l-2.613-2.948s-1.365-1.022-2.933-1.255l-5.778-.672s-.9 0-1.017.672c0 0-.116.467.552 1.021 0 0 .465.555.116 1.256 0 0-.464.788.552 1.926 0 0 .348.555.552 1.139l1.016 2.51s.348.905 1.249.905l6.33.905 1.974-5.459z"
        fill="#F9C8BC"
        fillRule="nonzero"
      />
      <g transform="translate(130.158)" fillRule="nonzero">
        <path
          fill="#9BC3D3"
          d="M67.599 13.687L25.533 55.454.118 44.527l41.918-38.33z"
        />
        <path
          fill="#FFF"
          d="M16.297 32.367l19.738-17.182 13.532 5.874-18.415 17.653z"
        />
        <path
          fill="#DEEDF2"
          d="M23.474 28.432l10.855-9.546 1.706.411-10.972 9.751zM22.592 33.366l10.854-9.575 1.707.44-10.973 9.752zM30.034 30.84l10.855-9.575 1.706.44-10.972 9.752z"
        />
        <path
          fill="#9BC3D3"
          d="M16.297 32.367L14.62 16.712 34.447.264l1.588 14.921z"
        />
        <path
          fill="#DEEDF2"
          d="M17.209 29.518L15.944 17.74l17.12-14.597 1.177 11.014z"
        />
        <path
          fill="#1BB3BC"
          d="M29.034 16.595l-.677-6.609L32.3 6.55l.647 6.55z"
        />
        <path
          fill="#FFF"
          d="M23.474 15.42l-.117-.852 3.97-3.436.03.822zM23.563 17.476l-.118-.852 3.971-3.436v.822zM23.621 19.973l-.088-.852 1.971-1.704.03.823zM16.297 32.367l.117 1.175L31.3 40.033l-.147-1.321z"
        />
        <path
          fill="#DEEDF2"
          d="M49.567 21.06l.176 1.585L31.3 40.033l-.147-1.321z"
        />
        <g fill="#F9C8BC" transform="translate(22.65 15.273)">
          <ellipse cx={20.297} cy={31.105} rx={4.265} ry={4.259} />
          <path d="M21.798 27.11L34.21 30.4l-2.382 8.459-13.65-4.054zM21.798 27.11L7.384 14.833 3.706 18.18l13.032 15.303z" />
          <path d="M3.706 18.181l3.678-3.348-2.354-3.79s-1-1.41-2.559-.322L.324 12.63s-.765 1.439.558 2.878l2.824 2.673zM20.386 3.7l24.21.03-3.972 6.227-23.739-2.585zM16.885 7.372L12.62 5.463s-1.206-.117-1.089-1.498l.883-1.85L16.09.294s.794-.353 1.853.88l2.383 2.527-3.442 3.671z" />
        </g>
        <g transform="translate(29.416 15.273)">
          <path
            d="M20.18 53.045L.559 43.852s-1.265 2.408 1.088 3.936L20.062 56.1c13.473.969 28.534-10.398 29.946-23.498 0 0-.412-1.82-2.089-2.614 0 .03-13.09 12.542-27.74 23.057z"
            fill="#9BC3D3"
          />
          <path
            d="M20.15 53.104c17.885-1.91 30.858-17.946 28.917-35.834l-.883-8.253s-1.03-6.139-7.854-5.404L21.856 28.608 20.15 53.104z"
            fill="#1BB3BC"
          />
          <path
            d="M36.741 10.31l-9.296 12.394s6.12 2.35 11.414-3.495c0 0 3.089-6.08-2.118-8.9z"
            fill="#F9BEB0"
          />
          <ellipse
            fill="#F9C8BC"
            cx={32.387}
            cy={10.75}
            rx={10.708}
            ry={10.691}
          />
          <path
            d="M21.739 11.925s3.383.734 3.97 2.526c.619 1.791 1.442 4.053 2.737 4.347 0 0-.589-3.055 1.618-2.967 0 0 1.412-.147 1.706 1.763 0 0 .617 2.173-1.736 3.583 0 0 4.766 1.645 9.649-2.673 0 0 5.324-4.376 2.559-11.778 0 0-2.56-7.255-11.09-6.58.059 0-10.12 1.264-9.413 11.779z"
            fill="#000"
          />
          <path
            d="M26.416 28.755l-7.295-1.293s-5.737 2.468-3.942 9.605l8.854 2.555 2.383-10.867z"
            fill="#E59D27"
          />
        </g>
        <ellipse fill="#EC0000" cx={20.121} cy={20.149} rx={2} ry={2.497} />
        <ellipse fill="#E59D27" cx={54.862} cy={49.52} rx={5.589} ry={5.581} />
      </g>
      <path
        fill="#137E84"
        fillRule="nonzero"
        d="M180.725 54.333l3.165 1.03L180.553 57z"
      />
      <path
        fill="#E59D27"
        fillRule="nonzero"
        d="M228.657 3.167l2.123-2.122 2.124 2.122-2.124 2.121z"
      />
      <path
        d="M185.893 122s-1.81-.147-4.005-.852l2.966-6.815 3.708 1.469-2.67 6.198z"
        fill="#732645"
        fillRule="nonzero"
      />
      <path
        d="M204.916 99.812c0-10.535-8.563-18.268-19.038-19.094-10.24-.797-18.714 7.762-19.009 18.386 0 0 0 4.78 1.501 8.263l24.099 10.3 12.447-17.855z"
        fill="#DEEDF2"
        fillRule="nonzero"
      />
      <path
        d="M168.44 107.333s.687 1.782 1.435 2.629l-2.004 4.73 4.787-.263s4.01 4.44 9.575 6.571l2.992-6.775-16.786-6.892z"
        fill="#DEEDF2"
        fillRule="nonzero"
      />
      <path
        d="M186.226 121.87s16.302 2.218 23.696-11.698c0 0-2.316-3.764-5.612-4.172l-14.224 7.148-3.86 8.723z"
        fill="#F9BEB0"
        fillRule="nonzero"
      />
      <g fillRule="nonzero">
        <g fill="#FFF" transform="translate(169.873 82)">
          <ellipse cx={19.885} cy={18.892} rx={18.653} ry={18.716} />
          <path d="M.03 30.84l3.079-6.21 4.839 1.266-1.261 4.885z" />
        </g>
        <path
          d="M193.981 98.361c-.059-.706-.234-1.412-.616-2l-3.167-5.562a5.409 5.409 0 0 1-.528-1.354l-.147.235a4.453 4.453 0 0 0 0 4.444l2.581 4.443a4.453 4.453 0 0 1 0 4.444l-.147.235c-.088-.47-.293-.941-.527-1.353l-2.347-4.061-1.495-2.62a5.409 5.409 0 0 1-.528-1.353l-.147.236c-.792 1.353-.792 3.03 0 4.443l2.58 4.444a4.453 4.453 0 0 1 0 4.443l-.146.235c-.088-.47-.293-.941-.528-1.353l-3.226-5.562a5.034 5.034 0 0 1-.616-2.442c-3.402.882-5.777 2.795-5.777 5.002 0 3.09 4.575 5.562 10.235 5.562 5.66 0 10.236-2.472 10.236-5.562.088-2.119-2.258-4.06-5.69-4.944z"
          fill="#EC0000"
        />
      </g>
      <path
        fill="#F9BEB0"
        fillRule="nonzero"
        d="M254.883 36.194l1.095-2.527-2.003 2.305.313 1.028zM265.656 180.688l-1.335-3.355.668 4.667zM188.53 134l-10.253 5.348-2.73 6.319 15.685-7.053s-.668-2.85-2.701-4.614z"
      />
    </g>
  </svg>
);

export default SVGLoginIllustration;
